import React from 'react';
import {
  useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  VStack,
  Heading,
  Text,
  Button,
  Icon,
  Image,
} from '@chakra-ui/react';
import { FaCog, FaArrowLeft } from 'react-icons/fa';
import AppLayout from './AppLayout';

const ComingSoon = ({ 
  title = 'Próximamente', 
  message = 'Esta funcionalidad estará disponible muy pronto',
  userType = 'banda' 
}) => {
  const navigate = useNavigate();

  return (
    <AppLayout>
      <Container maxW="4xl" py={20}>
        <VStack gap={8} textAlign="center">
          <Box position="relative">
            <Image
              src="/capirote-mantenimiento.png"
              alt="Próximamente"
              maxW="200px"
              css={{
                '& @keyframes float': {
                  '0%, 100%': { transform: 'translateY(0px)' },
                  '50%': { transform: 'translateY(-20px)' }
                },

                animation: 'float 3s ease-in-out infinite'
              }}
            />
            <Box
              position="absolute"
              top="-20px"
              right="-20px"
              css={{
                '& @keyframes spin': {
                  from: { transform: 'rotate(0deg)' },
                  to: { transform: 'rotate(360deg)' }
                },

                animation: 'spin 3s linear infinite'
              }}
            >
              <Icon boxSize={12} color="purple.400" asChild><FaCog /></Icon>
            </Box>
            <Box
              position="absolute"
              bottom="-10px"
              left="-30px"
              css={{
                '& @keyframes spin': {
                  from: { transform: 'rotate(0deg)' },
                  to: { transform: 'rotate(360deg)' }
                },

                animation: 'spin 4s linear infinite reverse'
              }}
            >
              <Icon boxSize={8} color="gold.400" asChild><FaCog /></Icon>
            </Box>
          </Box>

          <VStack gap={4} maxW="2xl">
            <Heading size="2xl" color="purple.600">
              {title}
            </Heading>
            <Text fontSize="xl" color="gray.600">
              {message}
            </Text>
            <Text fontSize="md" color="gray.500">
              Estamos trabajando para traerte la mejor experiencia. Te avisaremos por email cuando esta sección esté lista.
            </Text>
          </VStack>

          <Box
            bg="purple.50"
            border="2px solid"
            borderColor="purple.200"
            rounded="2xl"
            p={6}
            maxW="2xl"
          >
            <VStack gap={3}>
              <Icon boxSize={8} color="purple.600" asChild><FaCog /></Icon>
              <Text fontSize="md" fontWeight="600" color="purple.700">
                ¿Qué puedes hacer mientras tanto?
              </Text>
              <VStack gap={2} align="start" w="full" px={4}>
                <Text fontSize="sm" color="gray.700">• Completa tu perfil al 100%</Text>
                <Text fontSize="sm" color="gray.700">• Explora la comunidad de bandas y cofradías</Text>
                <Text fontSize="sm" color="gray.700">• Revisa tu calendario de disponibilidad</Text>
                <Text fontSize="sm" color="gray.700">• Solicita la verificación de tu perfil</Text>
              </VStack>
            </VStack>
          </Box>

          <Button
            colorPalette="purple"
            size="lg"
            onClick={() => navigate(`/${userType}/perfil`)}
            mt={4}><Icon asChild><FaArrowLeft /></Icon>Volver a mi perfil
                      </Button>
        </VStack>
      </Container>
    </AppLayout>
  );
};

export default ComingSoon;
